<template>
  <div class="overlay-wrapper">
    <div v-show="message" class="overlay"/>
    <PrimaryCard v-show="message" class="overlay message">
      {{ message }}
    </PrimaryCard>
    <slot/>
  </div>
</template>
<script>
import { PrimaryCard } from '@mikmak/components';

export default {
  props: {
    message: String,
  },
  components: {
    PrimaryCard,
  },
};
</script>

<style lang="scss" scoped>
.overlay-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .overlay {
    width: 100%;
    height: 100%;
    opacity: 0.75;
    position: absolute;
    background-color: #FFF;
  }

  .message {
    opacity: 1;
  }

  ::v-deep .main-card-wrapper.primary {
    height: fit-content;
    width: fit-content;
    min-width: 193px;
    font-size: 16px;
  }
}
</style>
